import { render, staticRenderFns } from "./HolidaysEntitlement.vue?vue&type=template&id=3a9fbb2f&"
import script from "./HolidaysEntitlement.vue?vue&type=script&lang=js&"
export * from "./HolidaysEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysEntitlement.vue?vue&type=style&index=0&id=3a9fbb2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports